export var DropdownBaseCls = [
    'items-center',
    'flex',
    'cursor-pointer',
    'text-brand-600',
    'text-sm',
    'pt-px-5',
    'pb-px-5',
    'pl-px-12',
    'pr-px-12',
];
export var DropdownBorderedCls = [
    'border',
    'border-solid',
    'border-brand-600',
    'rounded',
];
export var DropdownClsMap = {
    button: [
        'items-center',
        'flex',
        'cursor-pointer',
        'border',
        'border-solid',
        'border-brand-600',
        'rounded',
        'text-brand-600',
        'text-sm',
        'pt-px-5',
        'pb-px-5',
        'pl-px-12',
        'pr-px-12',
    ],
    text: [
        'items-center',
        'flex',
        'cursor-pointer',
        'text-brand-600',
        'text-sm',
        'pt-px-5',
        'pb-px-5',
        'pl-px-12',
        'pr-px-12',
    ],
    icon: ['items-center', 'flex'],
};
export var DropdownItemClsMap = {
    disabled: [
        'flex',
        'justify-between',
        'items-center',
        'pt-px-5',
        'pr-px-12',
        'pb-px-5',
        'pl-px-12',
        'text-sm',
        'cursor-pointer',
        'relative',
        'text-gray-400',
        'cursor-not-allowed',
    ],
    normal: [
        'flex',
        'justify-between',
        'items-center',
        'pt-px-5',
        'pr-px-12',
        'pb-px-5',
        'pl-px-12',
        'text-sm',
        'cursor-pointer',
        'relative',
        'text-gray-700',
        'hover:bg-gray-100',
        'hover:text-brand-600',
    ],
};
